import React from "react";
import DrawerTitle from "../Drawer/DrawerTitle";
import { set } from "react-hook-form";
import { AllTabType, ILatestChat } from "src/types/GlobalInterfaces";
import MyOrderIcon from "src/assets/images/website-images/my-order.png";
import HealthScoreIcon from "src/assets/images/website-images/health-score.png";
import MyAcivityIcon from "src/assets/images/website-images/activity-icon.png";
import { BellIcon, BellRingIcon, SettingsIcon } from "lucide-react";
import { useNavigate, useNavigation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/Store/store";
import { doctorMode, ImageBaseUrl } from "src/lib/constans";
import {
  getInitialsImage,
  convertToKebabCase,
  removeToken,
  checkAnyRedDot,
} from "src/helpers/helperFunctions";
import defaultProfileImage from "src/assets/images/default_profile_image.png";
import { capitalize } from "@mui/material";
import Cookies from "js-cookie";
import { removeAuth } from "src/Store/reducer";
import { removeAllIndicators } from "src/Store/redDots";
import RedDotCircle from "../RedDotCircle";

interface IProps {
  activeTab?: AllTabType;
  setActiveTab?: (tab: AllTabType) => void;
  onClose?: () => void;
}

const AccountTab: React.FC<IProps> = ({ activeTab, setActiveTab, onClose }) => {
  const handleTabChange = (tab: AllTabType) => {
    // Logic to handle tab change can be added here
    setActiveTab && setActiveTab(tab);
  };
  const { userDetails, unreadNotificationCount } = useSelector(
    (state: RootState) => state.appReducer
  );
  const { allIndicators } = useSelector((state: RootState) => state.redDots);
  const { latestChat } = useSelector((state: RootState) => state.chat);
  const navigate = useNavigate();

  let actions = [
    {
      title: "My Orders",
      icon: MyOrderIcon,
      onClick: () => handleTabChange("MyOrders"),
      const:
        allIndicators?.customerOrder + allIndicators?.customerPharmacyOrder,
    },
    {
      title: "Health Score",
      icon: HealthScoreIcon,
      onClick: () => {
        navigate("/health-score");
        onClose?.();
      },
    },
    {
      title: "My Activity",
      icon: MyAcivityIcon,
      onClick: () => handleTabChange("MyActivity"),
    },
  ];

  let tabsList = [
    {
      title: "My Results",
      icon: "my-results",
      screen: "MyResults",
      const: allIndicators?.customerResult,
    },
    {
      title: "My Appointment",
      icon: "my-appoinment",
      screen: "MyAppointment",
      const:
        allIndicators?.customerHomeCareOrder +
        allIndicators?.customerOnlineAppointment +
        allIndicators?.customerPhysicalAppointment,
    },
    {
      title: "My Doctor",
      icon: "my-doctor",
      screen: "MyDoctor",
      const:
        latestChat?.reduce(
          (acc: number, item: ILatestChat) => acc + (item?.unRead || 0),
          0
        ) +
        allIndicators?.prescribedPharmacy +
        allIndicators?.prescribedDiagnostic +
        allIndicators?.prescribedHomeCare,
    },
    {
      title: "Health Profile",
      icon: "health-profile",
      screen: "MyHealthProfile",
    },
    {
      title: "Notification",
      icon: "notify-icon",
      screen: "Notifications",
      const: unreadNotificationCount,
    },
    {
      title: "Manage Address",
      icon: "address-icon",
      screen: "ManageAddress",
    },
    {
      title: "Manage Notifications",
      icon: "notification-setting",
      screen: "ManageNotifications",
    },
  ];

  const dispatch = useDispatch<AppDispatch>();

  const handleLogOut = () => {
    Cookies.remove(doctorMode);
    removeToken();
    dispatch(removeAuth());
    dispatch(removeAllIndicators());
    window.location.href = "/";
    // window.location.reload();
  };

  return (
    <div className="w-full min-h-screen flex flex-col bg-white">
      {/* <button
        id="close-account-tab"
        className="w-[50px] h-[50px] absolute top-0 left-0 z-[2] opacity-0"
        onClick={() => onClose?.()}
      ></button> */}
      <div className="w-full sticky top-0 theme-gradient-green pb-8">
        <div className="w-full relative flex 2xl:px-4 px-3 2xl:py-6 py-4 items-center lg:gap-2 gap-1">
          <div className="w-[45px] h-[45px] min-w-[45px] min-h-[45px] lg:w-[5.2vw] lg:h-[5.2vw] 2xl:w-[4.7vw] 2xl:h-[4.7vw] rounded-full bg-white flex items-center justify-center overflow-hidden">
            <img
              src={userDetails?.profileImageUrl || ""}
              alt="Profile"
              onError={(e) => {
                e.currentTarget.src = defaultProfileImage;
                // e.currentTarget.classList.add("object-contain" , "!w-[80%]" , "!h-[80%]");
              }}
              className="w-full h-full object-cover rounded-full"
            />
          </div>
          <div>
            <p className="font-size-20px font-Poppins-Medium text-white">
              {capitalize(userDetails?.firstName || "") +
                " " +
                capitalize(userDetails?.lastName || "")}
            </p>
            <div className="flex items-center gap-4">
              <p className="font-size-16px font-Poppins-Regular text-white">
                {userDetails?.email}
              </p>
              {userDetails?.userRole === "customer" ? (
                <button
                  className="bg-white absolute bottom-2 right-2 xl:bottom-0 xl:right-0  xl:relative rounded px-2 min-w-[60px] py-1 font-size-14px font-Poppins-Medium theme-color-green-3f"
                  onClick={() => handleTabChange("EditProfile")}
                  id={"edit-profile"}
                >
                  Edit
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className="flex relative z-10 -mt-8 w-full 2xl:rounded-tl-3xl 2xl:rounded-tr-3xl rounded-tl-xl rounded-tr-xl bg-white 2xl:px-4 px-3 2xl:pt-6 pt-4 2xl:pb-4 pb-3 flex-col justify-between gap-3">
        <div className="w-full flex flex-col xl:gap-4 gap-3">
          <div className="w-full flex items-center justify-evenly">
            {actions.map((action, index) => (
              <div
                key={index}
                className="flex flex-col items-center cursor-pointer"
                onClick={action.onClick}
                id={convertToKebabCase(action.title)}
              >
                <div className="w-[55px] relative h-[55px] 2xl:w-[70px] 2xl:h-[70px] border border-[#00615B] rounded-full flex items-center justify-center">
                  <img
                    src={action.icon}
                    alt={action.title}
                    className="max-w-[50%] max-h-[50%] 2xl:max-w-[80%] 2xl:max-h-[80%] object-contain"
                  />
                  {action.const ? (
                    <RedDotCircle
                      count={action.const}
                      placement="top-right"
                      showCount={false}
                      className="top-[3px] right-[3px]"
                    />
                  ) : null}
                </div>
                <p className="font-size-15px font-Poppins-SemiBold theme-color-green 2xl:mt-2 mt-1">
                  {action.title}
                </p>
              </div>
            ))}
          </div>
          <div className="w-full shadow-all rounded-lg flex flex-col 2xl:gap-4 gap-3 2xl:p-4 p-3">
            {tabsList.map((tab, index) => (
              <div
                className="w-full flex gap-2 items-center cursor-pointer"
                onClick={() => handleTabChange(tab.screen as AllTabType)}
                id={convertToKebabCase(tab.title)}
              >
                <div className="w-[20px] h-[20px] 2xl:w-[30px] 2xl:h-[30px] flex items-center justify-center">
                  {typeof tab.icon === "string" ? (
                    <img
                      src={
                        tab.icon
                          ? require(`src/assets/images/website-images/${tab.icon}.png`)
                          : ""
                      }
                      alt={tab.title}
                      className="max-w-full max-h-full object-contain"
                    />
                  ) : (
                    <>{tab.icon}</>
                  )}
                </div>
                <p className="relative font-size-15px font-Poppins-Medium text-[#4B5563]">
                  {tab.title}
                </p>
                {tab.const ? (
                  // <div className=" bg-red-500 text-white text-[6px] 2xl:text-[9px] rounded-full px-1 py-0.5 w-[12px] 2xl:w-[15px] aspect-square flex items-center justify-center">
                  //   <span className="mb-[-3px]">{tab.const}</span>
                  // </div>
                  <RedDotCircle
                    count={tab.const}
                    placement="top-right"
                    showCount={false}
                    className="relative !top-0 !right-0"
                  />
                ) : null}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="w-full p-2 2xl:p-3 bg-white absolute bottom-0 left-0 right-0 z-[2] flex items-center justify-center">
        <button
          className="w-[95%] mx-auto bg-[#FEF2F2] rounded-full text-[#EB1D32] py-2 text-center font-Lexend-Medium font-size-18px "
          id={"logout-button"}
          onClick={handleLogOut}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default AccountTab;
